<template>
  <div>
    <div v-if="dataloaded">
      <div class="container info_page dark:text-white" v-html="acco.policy"></div>
    </div>
    <div v-else class="fullpageLoader">
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import VueMeta from "vue-meta";

Vue.use(Viewer);
Vue.use(VueMeta);

Vue.prototype.moment = moment;
export default {
  data() {
    return {
      metaTitle: "",
      metaDescription: "",
      dataloaded: false,
    };
  },
  metaInfo() {
    return {
      title: this.metaTitle,
      titleTemplate: "%s | "+process.env.MIX_BMB_CLIENT_NAME,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.metaDescription,
        },
      ],
    };
  },

  methods: {

    async getData() {
      try {
        // var listing = window.location.href.split("/").pop();
        let response = await fetch(
          this.$BMB_API +'api/' +
          this.$clientID +
            "/getProperty/" +
            $("#listingid").html(),
          {
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
              "Accept-Language": document.documentElement.lang
            },
          }
        );
        this.products = await response.json();

        this.dataloaded = true;
      } catch (error) {
        console.log(error);
      }
    }
  },

  created() {
    this.getData();
    this.currentUrl = window.location.origin;
    this.htmlLang = document.documentElement.lang.toUpperCase();
  },

  filters: {
    lowercase: function (string) {
      return string.toLowerCase();
    },
  },

  computed: {
    acco: function () {
      if (this.dataloaded) {
        this.metaTitle = this.products.name;
        this.metaDescription = JSON.parse(this.products.description)[
          this.htmlLang
        ];
        return this.products;
      }
    }
  },
};
</script>
